import React from "react";
import Icon from "../../../../../shared/components/ui/icons/Icon";
import iconsList from "../../../../../shared/components/ui/icons/iconsList";
import CardStatus from "./cardStatus/CardStatus";
import classes from "./FinalProjectCard.module.css";


const FinalProjectCard = ({ className, text, date, type, statusText, statusDate, isFocused }) => {


    return (
        <div className={`${classes.SubmissionStep} ${className} ${isFocused ? classes.Focused : ''}`} data-focused-card={isFocused ? "true" : undefined}>
            {isFocused && (
                <div className={classes.FocusIcon}>
                    <Icon name={iconsList.focusIcon} size="36.848px" className={classes.FocusIconSvg} />
                </div>
            )}
            <div className={classes.Title}>{text}</div>
            <div className={classes.Date}>{date}</div>
            <div className={classes.StatusBar}>
                <CardStatus type={type} text={statusText} date={statusDate} />
            </div>
        </div>
    )
}

export default FinalProjectCard;
